import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ErrorModal = ({
  isOpen,
  handleClose,
  errorMessage,
}) => {
  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="xs">
      <Box sx={{ padding: '16px' }}>
        <DialogTitle sx={{ position: 'relative', padding: '10px 16px 0', marginBottom: '20px' }}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 0,
              top: 0,
              color: 'rgba(0, 0, 0, 0.54)',
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '18px', color: '#D32F2F' }}>
              Error
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ padding: '16px 16px 16px 16px' }}>
          <Typography sx={{ fontSize: '14px', fontWeight: 300, color: '#475467', marginBottom: '10px', textAlign:'center' }}>
            {errorMessage}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", padding: "8px 16px", marginTop: '0' }}> {/* Center the button */}
          <Button
            onClick={handleClose} // Close the modal
            variant="contained"
            sx={{
              background: "#D32F2F", // Error color
              borderRadius: "8px",
              height: "48px", // Match height
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography sx={{ color: "white", fontWeight: 600, fontSize: "16px", marginRight: "5px" }}>
              Close
            </Typography>
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

ErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired,
};

export default ErrorModal;